module.exports = __webpack_public_path__ + "img/mystery_box.94f456e7.png";